// Data quality is a work queue of the app (`/data-quality`), not a setting: old links and bookmarks land there.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { DataQualitySearch } from '../../../features/quality/search';

export const Route = createFileRoute('/_settings/settings/data-quality')({
  validateSearch: DataQualitySearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/data-quality', search, replace: true });
  },
});
